jQuery(($) => {

    if ($('.m-search-dropdown')[0]) {
        $('.m-search-dropdown__search-button').click(function (e) {
            e.preventDefault(); 

            var toggle = $(this),
                module = toggle.parent();

            module.toggleClass('m-search-dropdown--active');

            module.find('.m-search-dropdown__input').focus();

            if (module.hasClass('m-search-dropdown--active')) {
                $(document).on('click', function (event) {
                    if (!$(event.target).closest('.m-search-dropdown').length) {
                        module.removeClass('m-search-dropdown--active');
                    }
                });

                $(document).on('keydown', function (event) {
                    if (event.keyCode === 9) { // Tab key code
                        if ($('.m-search-dropdown--active')[0] && !$(event.target).closest('.m-search-dropdown').length) {
                            $('.m-search-dropdown').removeClass('m-search-dropdown--active');
                        }
                    }
                });
            }
        });
    }
});    